import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  operation: 'uppercase',
  field: '',
  // Concat
  strings: {
    values: [
      { value: '' },
      { value: '' },
    ],
  },
  separator: '',
  // Replace
  searchValue: '',
  replaceValue: '',
  // Substring
  start: 0,
};

export default defaults;
